export const statAbbreviations = new Map<string, string>([
    ['strength', 'STR'],
    ['agility', 'AGI'],
    ['vitality', 'VIT'],
    ['intellect', 'INT'],
    ['luck', 'LUCK'],
    ['defense', 'DEF']
]);
